export default __webpack_public_path__ + "static/media/slider-Arrow-Right.63832212.svg";